import { Grid } from "@material-ui/core";
import React from "react";
import Page from "../../ui/page";
import { QueryContextProvider } from "./context";
import QueryForm from "./form";
import QueryChips from "./form/queryChips";
import "./query.css.scss";
import QueryResult from "./result";

export default () => {
  return (
    <Page headerProps={{ icon: "fa fa-search", title: "Busca" }}>
      <QueryContextProvider>
        <Grid container spacing={3}>
          <Grid item xs={12} md={3}>
            <QueryChips />
            <QueryForm />
          </Grid>

          <Grid item xs={12} md={9}>
            <QueryResult />
          </Grid>
        </Grid>
      </QueryContextProvider>
    </Page>
  );
};
